import React from 'react';
import { Box } from '@mui/material';
import { estiloEtiquetaChica } from '../../styles/tokensAU';

const EtiquetaAU = ({ children, component = 'span', sx, ...resto }) => (
  <Box component={component} sx={[estiloEtiquetaChica, ...(Array.isArray(sx) ? sx : [sx])]} {...resto}>
    {children}
  </Box>
);

export default EtiquetaAU;
